import React from 'react';
import { ContextExtensionModule, ContextExtensions } from '@go-shared/types/go-modules/goModules';
import { MenuRenderer } from '@go-client/go-modules/core/ExtensionPoints/Renderers/MainMenuRenderer';
import { ExtensionPointNamespace } from '@go-shared/types/go-modules/extensionPoints';
import { DefaultRenderer } from '@go-client/go-modules/core/ExtensionPoints/Renderers/DefaultRenderer';

let rendererMap: {
  [key in ExtensionPointNamespace]: { new (): ExtensionPointRenderer } | undefined;
};

rendererMap = {
  [ExtensionPointNamespace.UI_MENU]: MenuRenderer,
  [ExtensionPointNamespace.UI_LIBRARY_VENUES_LEFTBAR]: undefined,
  [ExtensionPointNamespace.UI_ITINERARY_LEFTBAR]: undefined,
};

export interface ExtensionPointRenderer {
  render(ctxExtensionModules: ContextExtensionModule[], data: any, events: any): JSX.Element;
}

class RendererFactory {
  static createRenderer(namespace: ExtensionPointNamespace): ExtensionPointRenderer | undefined {
    const RendererClass = rendererMap[namespace];

    return RendererClass ? new RendererClass() : undefined;
  }
}

export function ExtensionPointRender(
  namespace: ExtensionPointNamespace,
  cxtExtensions: ContextExtensions,
  data: any,
  events: any
): JSX.Element {
  const defaultRenderer = new DefaultRenderer();
  const ctxExtensionModules = cxtExtensions[namespace];

  // use default renderer if namespace does not have one assigned
  const renderer = RendererFactory.createRenderer(namespace) || defaultRenderer;

  const extensionWithContribution = ctxExtensionModules.filter(
    e => e.contribution !== undefined && Object.keys(e.contribution).length
  );
  const extensionWithoutContribution = ctxExtensionModules.filter(
    e => e.contribution === undefined || !Object.keys(e.contribution).length
  );

  const elementsToRender = [];

  // elements defined by the renderer
  if (extensionWithContribution && extensionWithContribution.length > 0) {
    elementsToRender.push(renderer.render(extensionWithContribution, data, events));
  }

  // elements overriding the renderer
  if (extensionWithoutContribution && extensionWithoutContribution.length > 0) {
    elementsToRender.push(defaultRenderer.render(extensionWithoutContribution, data, events));
  }

  if (elementsToRender.length) {
    return (
      <>
        {elementsToRender.map((element, index) => (
          <React.Fragment key={index}>{element}</React.Fragment>
        ))}
      </>
    );
  }

  return <></>;
}
